module.exports = __webpack_public_path__ + "img/cns_email_pc7.1bc2aac1.png";